import { useEffect, useState } from "react";
import { AutoComplete } from "primereact/autocomplete";
import FuncionarioService from "../../services/resource/funcionarioService";

const funcionarioService = new FuncionarioService();

const INPUT_CLASS_PADRAO = "w-full h-9 pl-3 pr-8 text-sm border border-input rounded-lg bg-card outline-none focus:border-primary focus:ring-2 focus:ring-primary/15";

/**
 * Autocomplete de funcionário: pesquisa por nome direto no backend (GET /api/funcionarios/v1?nome=)
 * em vez de carregar a base inteira de uma vez — importante porque o cadastro de funcionários pode
 * ser grande. `onChange` só dispara numa seleção explícita (ou ao limpar pelo "x") — nunca durante
 * a digitação em si — pra ser seguro usar como gatilho de salvamento imediato (ex.: edição inline).
 */
export default function FuncionarioAutoComplete({ value, onChange, placeholder = "Selecione um funcionário", disabled = false, inputClassName, autoFocus = false }) {
    const [termo, setTermo] = useState(value?.nome || "");
    const [sugestoes, setSugestoes] = useState([]);

    // Mantém o texto exibido sincronizado quando o valor selecionado muda por fora (ex.: ao abrir
    // o modal de edição já com um funcionário vinculado).
    useEffect(() => {
        setTermo(value?.nome || "");
    }, [value?.id, value?.nome]);

    function buscar(evento) {
        const query = evento.query.trim();
        if (query.length < 2) {
            setSugestoes([]);
            return;
        }
        funcionarioService.listar({ nome: query })
            .then(res => setSugestoes(res.data || []))
            .catch(() => setSugestoes([]));
    }

    function selecionar(evento) {
        setTermo(evento.value.nome);
        onChange(evento.value);
    }

    function aoMudarTexto(evento) {
        const valor = evento.target.value;
        if (typeof valor === "string") setTermo(valor);
    }

    function limpar() {
        setTermo("");
        onChange(null);
    }

    // Se o usuário digitar e sair sem selecionar nada da lista, o texto volta a refletir o
    // funcionário realmente vinculado (ou fica vazio, se nenhum estiver selecionado) — digitar não
    // desvincula por si só, só a seleção ou o botão de limpar fazem isso.
    function aoSair() {
        const nomeSelecionado = value?.nome || "";
        if (termo !== nomeSelecionado) setTermo(nomeSelecionado);
    }

    return (
        <div className="relative w-full">
            <AutoComplete
                value={termo}
                suggestions={sugestoes}
                completeMethod={buscar}
                field="nome"
                onChange={aoMudarTexto}
                onSelect={selecionar}
                onBlur={aoSair}
                disabled={disabled}
                autoFocus={autoFocus}
                placeholder={placeholder}
                className="w-full"
                inputClassName={inputClassName || INPUT_CLASS_PADRAO}
                panelClassName="text-sm"
                itemTemplate={item => (
                    <div>
                        <div className="font-medium">{item.nome}</div>
                        {item.cargo && <div className="text-xs text-muted-foreground">{item.cargo}</div>}
                    </div>
                )}
                emptyMessage="Nenhum funcionário encontrado"
            />
            {value && !disabled && (
                <button
                    type="button"
                    onClick={limpar}
                    title="Remover funcionário vinculado"
                    className="absolute right-2 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-destructive"
                >
                    <i className="fa fa-times text-xs" />
                </button>
            )}
        </div>
    );
}
